import { FEATURES } from '@/constants';

const getters = {
  filters: state => state.filters,

  searchTags: state => state.searchTags,

  accessibleColumns: (state, gttrs, rootState, rootGttrs) => {
    const canUseFeature = rootGttrs['features/canUseFeature'];
    const canShareLesson =
      canUseFeature(FEATURES.ASSIGN_LESSONS_TO_LEARNERS_BY_GUARDIAN_PERMISSIONS) ||
      canUseFeature(FEATURES.ASSIGN_LESSON_TO_LEARNERS_IN_MY_CLASSES);

    return canShareLesson ? state.columns : state.columns.filter(col => col.field_name !== 'share');
  },

  visibleColumns: (state, gttrs) => gttrs.accessibleColumns.filter(column => column.showColumn),

  filtersApplied: state => Object.values(state.filters).filter(Boolean),

  hasFiltersApplied: (state, gttrs) => gttrs.filtersApplied.length > 0,

  levels: state => state.levels || [],
};

export default getters;
